/* eslint eqeqeq: 0 */
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import DataTable from 'react-data-table-component';
import { faSquareCheck, faSquarePlus, faPenToSquare } from "@fortawesome/free-regular-svg-icons";
import { faCircleInfo, faLink } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Spinner, Modal, Button, Form } from 'react-bootstrap';
import Select from 'react-select';
import Pengaturan from './components/pengaturan';
//import 'react-select-2/dist/css/react-select.css';
function Customer(){
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [search, setSearch]=useState('');
    const [diCari, setDiCari]=useState('');
    const [show, setShow] = useState(false);
    const [isiForm, setIsiForm]=useState('');
    const [judulModal, setJudulModal]=useState('');
    let profileBaru;
    let jmlHari;
    let idCust;
    const handleShow=()=>setShow(true);
    const handleClose=()=>setShow(false);
    const formData = new FormData();
    const paramAktifkan = new FormData();
    //
    const myNewTheme= {
        rows: {
          fontSize: '150px'
        }
      }
    const columns = [
        {
            cell: (row) => <span style={{fontSize: 18}}><span style={{cursor:'pointer'}} onClick={()=>detailCustomer(row)}><FontAwesomeIcon icon={faCircleInfo} /></span>&nbsp;
            <span style={{cursor:'pointer'}}>{btnAktifkan(row)}</span>&nbsp;<span style={{cursor:'pointer'}}>{editCust(row)}</span></span>,
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            selector:row=>row.id,
            width:'100px'
        },
        {
            name: 'User Name',
            selector: row => <>{row.name} {row.id_konsumen}</>,
            sortable: true,
        },
        {
            name: 'Profile',
            cell: (row) =><>{apakahIsolir(row)}</>,
            sortable: true,
        },
        {
            name: 'Isolir',
            selector: row => row.tgl_isolir,
            sortable: true,
        },
        {
            name: 'Status',
            selector: row => row.status,
            sortable: true,
            width:'80px'
        },
        {
            name: 'Nama',
            selector: row => row.nama,
            sortable: true,
        },
    ];
    //
    const detailCustomer=(row)=>{
        setJudulModal('Detail Cutomer');
        setIsiForm(
            <>
            <table className='table'>
                <tr>
                    <td>Secret name </td>
                    <td>{row.name}</td>
                </tr>
                <tr>
                    <td>Profile Terakhir </td>
                    <td>{row.profile}</td>
                </tr>
                <tr>
                    <td>Status Akun </td>
                    <td>{row.status}</td>
                </tr>
                <tr>
                    <td>Tgl. Isolir</td>
                    <td>{row.tgl_isolir}</td>
                </tr>
                <tr>
                    <td>Terakhir Logout</td>
                    <td>{row.lastloggedout}</td>
                </tr>
                <tr>
                    <td>Nama Konsumen </td>
                    <td>{row.nama}</td>
                </tr>
                <tr>
                    <td>Alamat </td>
                    <td>{row.alamat}</td>
                </tr>
                <tr>
                    <td>No. Tlp </td>
                    <td>{row.tlp}</td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                </tr>
            </table>
            <Button variant="secondary" onClick={handleClose}>
                Close
            </Button>
            </>
        );
        handleShow();
    }
    //
    const editCust=(r)=>{
        let icon,title;
        if(r.terhubung=='1'){icon=faPenToSquare; title='Edit'; }
        else{icon=faLink; title='Hubungkan dengan Konsumen'; }
        return(
            <span title={title} onClick={()=>formPenghubung(r)}>&nbsp;<FontAwesomeIcon icon={icon} />&nbsp;</span>
        )
    }
    const btnAktifkan=(r)=>{
        let icon;
        if(r.profile=='profile-isolir'){ icon=faSquareCheck; }
        else {icon = faSquarePlus; }
        return(
                <span onClick={()=>formAktifkan(r)}>&nbsp;<FontAwesomeIcon icon={icon} />&nbsp;</span>
            )
    }
    const formAktifkan=async(r)=>{
        profileBaru='';
        jmlHari='0';
        let pr,listProfile,slct,optProfile,pilProf;
        if(r.profile == 'profile-isolir'){
            pr='';
            setJudulModal('Mengaktifkan Konsumen');
            await axios.get(Pengaturan['urlApi']+'billinggetprofile?router='+localStorage.getItem('rtr'))
            .then((response) => {
                listProfile=response.data;
                optProfile = listProfile.map((item,i) => {
                    if(listProfile[i] == pr) slct=listProfile[i];
                    return (
                        <option key={i} value={listProfile[i]}>{listProfile[i]}</option>
                    )
                }, this);
            });
            pilProf=
            <Form.Group>
                <Form.Label>Pilih Profile Baru</Form.Label>
                <select defaultValue={slct} className="form-control" onChange={(event)=>{profileBaru= event.target.value}}>
                    <option value="">Pilih Profile Baru</option>
                    {optProfile}
                </select>
            </Form.Group>
        }else{
            pr=r.profile;
            setJudulModal('Tambah Masa Aktif');
            pilProf=
            <Form.Group>
                <Form.Label>Tentukan Jumlah Hari Tambahan</Form.Label>
                <input type="number" onKeyUp={(event)=>{jmlHari = event.target.value}} className="form-control"/>
            </Form.Group>
        }
        
        setIsiForm(
        <>
            <Form>
                <Form.Group>
                    <Form.Label>Username : <strong>{r.name}</strong></Form.Label>
                </Form.Group>
                {pilProf}
                <hr />
                <Form.Group>
                    <Button className="form-control" variant="primary" onClick={()=>aktifkan(r)}>Simpan</Button>&nbsp;
                    <Button className="form-control" variant="secondary" onClick={handleClose}>Close</Button>
                </Form.Group>
            </Form>
        </>)
        handleShow();
    }
    const aktifkan=async(row)=>{
        let psnError='';
        console.log('pro',profileBaru);
        console.log('jmlhr',jmlHari);
        if(row.profile=='profile-isolir' && profileBaru.length == 0){psnError='Profile Belum dipilih';}
        if(row.profile != 'profile-isolir' && jmlHari == '0'){psnError='Jumlah Hari Belum ditentukan';}
        if(psnError.length > 0){            
            setJudulModal('Error');
            setIsiForm(<><strong>{psnError}</strong><br /><Button className="form-control" variant="secondary" onClick={handleClose}>Close</Button></>);
        }else{
            paramAktifkan.append('profile', profileBaru);
            paramAktifkan.append('jmlhari', jmlHari);
            paramAktifkan.append('router', localStorage.getItem('rtr'));
            paramAktifkan.append('secretname', row.name);
            paramAktifkan.append('id', row.id);
            setIsiForm('Sedang Mengaktivasi, Mohon Tunggu...');
            await axios.post(Pengaturan['urlApi']+'aktifkan', paramAktifkan)
            .then((response)=>{
                console.log(response.data);
                if(response.data == "1"){
                    fetchData();
                    handleClose();
                // window.location.reload(false); 
                }
            });
        }
    }
    const apakahIsolir=(row)=>{
        if(row.profile=='profile-isolir'){
            return(<span style={{color:"red"}}>{row.profile_lama}</span>)
        }else{
            return(<>{row.profile_lama}</>)
        }
    }
    const hubungkan=async()=>{        
        formData.append('id',idCust);
        formData.append('router',localStorage.getItem('rtr'));
        setIsiForm('Sedang Menyimpan, Mohon Tunggu...');
        await axios.post(Pengaturan['urlApi']+'hubungkankonsumen', formData)
        .then((response)=>{
            console.log(response.data);
            if(response.data == "OK"){
                fetchData();
                handleClose();
               // window.location.reload(false); 
            }
        });
    }
   const getSlected=(event)=>{
        idCust=event.value;
    }
    const formPenghubung=async(r)=>{   
        let isinya,apakahTerhubung,labelSelect,slct='';
        setIsiForm('Mohon Tunggu...');
        if(r.terhubung=='0') {
            setJudulModal('Hubungkan ke Database Konsumen');
            formData.append('act','insert')
            apakahTerhubung=''; 
            labelSelect='Pilih Konsumen';
            slct='';
        }
        else{
            setJudulModal('Ganti data Konsumen');
            formData.append('act','edit')
            apakahTerhubung='Sudah terhubung ke <strong>'+r.nama+'</strong>'; labelSelect='Ganti Konsumen';
        }     
        handleShow();
        formData.append('iduser',r.id);        
        await axios.get(Pengaturan['urlApi']+'forselect')
            .then((response) => {                
                isinya=response.data;
                if(r.terhubung=='1') {
                    for(let x=0; x<isinya.length; x++){
                        if(isinya[x]['value']==r.id_konsumen){
                            slct=isinya[x];
                            idCust=isinya[x]['value'];
                            break;
                        }
                    }
                }                
            });
        
        setIsiForm(
            <Form>
                <Form.Group>
                    <Form.Label>Username : <strong>{r.name}</strong></Form.Label>
                </Form.Group>
                <div dangerouslySetInnerHTML={{"__html": apakahTerhubung}}></div>
                <Form.Group className="mb-3" controlId="formIdKonsumen">
                    <Form.Label>{labelSelect}</Form.Label>
                    <Select 
                        options={isinya} 
                        onChange={getSlected} 
                        defaultValue={slct}>                        
                    </Select>
                </Form.Group>
                <Button variant="primary" onClick={hubungkan}>
                    Simpan
                </Button>&nbsp;
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
            </Form>
        );
    }
        
    const fetchData = async () =>{
        const params = {cari: search,router: localStorage.getItem('rtr')}
        setLoading(true);
        await axios.get(Pengaturan['urlApi']+'getallcustomer', {params})
        .then((response)=>{
            setPosts(response.data)
        });
        setLoading(false);
    };
    useEffect(()=>{
        fetchData();
    },[search]); 
    //get current post
       
    const isi=()=>{
        if(loading){
            return (
                <div className='row justify-content-center'>
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                </div>
            )
        }else{
            return(
            <div className='row justify-content-center'>
                <div className='col-md-12'>
                    <DataTable
                        className='table table-striped'
                        columns={columns}
                        data={posts}
                        pagination
                        customTheme={myNewTheme}
                    />
                </div>
            </div>
            )
        }
    }
    return(<>
            <div className='row justify-content-center'>
                <div className='col-md-4'><h3>Customer</h3></div>
                <div className='col-md-8'>
                    <input 
                        type='text' 
                        placeholder='Cari...' 
                        onChange={(e)=>{
                            if(e.target.value.length > 0){
                                setDiCari(e.target.value);
                            }else{
                                setSearch('');
                            } }} 
                        onKeyDown={(event) => {
                            if (event.key == 'Enter') {
                                setSearch(diCari)
                            }
                          }} />
                    <button className='btn btn-primary btn-sm' onClick={()=>{setSearch(diCari)}}>Cari</button>
                </div>
            </div>
            {isi()}
            <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
                <Modal.Header closeButton>
                <Modal.Title>{judulModal}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                {isiForm}
                </Modal.Body>
                <Modal.Footer>
                </Modal.Footer>
            </Modal>
        </>
    )
}
export default Customer;